import { topics } from '@/mocks/chigua';

export default function TopicSquare() {
  return (
    <section id="huati" className="scroll-mt-24 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="flex items-center gap-1.5 text-xs font-semibold tracking-widest text-primary-600">
              <i className="ri-chat-smile-2-line"></i> 话题广场
            </p>
            <h2 className="heading-font mt-1.5 text-2xl font-extrabold text-foreground-950 md:text-3xl">
              大家都在哪条话题里聊得正欢
            </h2>
          </div>
          <span className="hidden items-center gap-1.5 text-xs text-foreground-500 sm:flex">
            <i className="ri-focus-3-line text-primary-500"></i> 参与讨论会跳转到对应讨论页
          </span>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {topics.map((t) => (
            <article
              key={t.id}
              className="group overflow-hidden rounded-lg border border-secondary-100 bg-background-50 transition-all hover:-translate-y-1"
            >
              <a href="#ts" className="block" aria-label={`话题 ${t.title}`}>
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={t.img}
                    alt={t.title.replace(/[#]/g, '')}
                    className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                  {t.hot && (
                    <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded bg-primary-500 px-2 py-1 text-[10px] font-semibold text-background-50">
                      <i className="ri-fire-fill"></i> 热门
                    </span>
                  )}
                </div>
              </a>
              <div className="p-4 md:p-5">
                <h3 className="heading-font text-base font-bold text-foreground-950 md:text-lg">
                  <a href="#ts" className="transition-colors hover:text-primary-600">
                    {t.title}
                  </a>
                </h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{t.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-secondary-100 pt-3">
                  <div className="flex items-center gap-3 text-[11px] text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line text-primary-500"></i> {t.talks}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-user-heart-line"></i> {t.members}
                    </span>
                  </div>
                  <a
                    href="#ts"
                    className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600 transition-colors hover:text-primary-700"
                  >
                    去聊聊 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}